
import React from 'react';
import { Code, MessageCircle, Phone, Mail, Instagram, Facebook, MapPin, Monitor } from 'lucide-react';
import QRCodeGenerator from '../common/QRCodeGenerator';
import MapComponent from '../common/MapComponent';

const SoftwareLinktree = () => {
  const socialLinks = [
    { icon: Instagram, url: "https://www.instagram.com/decidedigitaloficial" },
    { icon: Facebook, url: "https://www.facebook.com/decidedigitaloficial" },
  ];

  const mainLinks = [
    {
      icon: Code,
      title: "Nossos Produtos",
      subtitle: "Software personalizado",
      url: "https://decidedigital.com.br/",
      gradient: "from-cyan-500 to-blue-600"
    },
    {
      icon: Monitor,
      title: "Demo Gratuita",
      subtitle: "Teste nossas soluções",
      url: "https://decidedigital.com.br/",
      gradient: "from-green-500 to-emerald-600"
    },
    {
      icon: MessageCircle,
      title: "Suporte Técnico",
      subtitle: "Atendimento especializado",
      url: "https://wa.me/5569992083972?text=Ol%C3%A1%20preciso%20de%20suporte%20t%C3%A9cnico",
      gradient: "from-green-600 to-teal-700"
    },
    {
      icon: Phone,
      title: "Comercial",
      subtitle: "(69) 99208-3972",
      url: "tel:+5569992083972",
      gradient: "from-blue-500 to-indigo-600"
    },
    {
      icon: Mail,
      title: "Desenvolvimento",
      subtitle: "contato@decidedigital.com.br",
      url: "mailto:contato@decidedigital.com.br",
      gradient: "from-purple-500 to-violet-600"
    }
  ];

  return (
    <div className="min-h-screen bg-gradient-to-br from-gray-900 via-blue-900 to-purple-900 py-8 px-4">
      <div className="max-w-md mx-auto">
        {/* Profile Section */}
        <div className="text-center mb-8 animate-fade-in">
          <div className="w-28 h-28 mx-auto mb-4 bg-gradient-to-br from-cyan-400 to-blue-600 rounded-2xl flex items-center justify-center shadow-2xl">
            <Code className="w-12 h-12 text-white" />
          </div>
          <h1 className="text-3xl font-bold text-white mb-2">DevSoft Solutions</h1>
          <p className="text-blue-200 leading-relaxed px-4 text-sm">
            💻 Desenvolvimento de software customizado e soluções tecnológicas 
            inovadoras para empresas de todos os portes.
          </p>
        </div>

        {/* QR Code for Portfolio */}
        <div className="bg-white/10 backdrop-blur-sm rounded-2xl p-4 mb-6 text-center animate-scale-in">
          <p className="text-white text-sm mb-3">📱 Portfólio Digital:</p>
          <div className="flex justify-center">
            <QRCodeGenerator url="https://decidedigital.com.br/" size={110} />
          </div>
        </div>

        {/* Social Icons */}
        <div className="flex justify-center space-x-4 mb-8">
          {socialLinks.map((social, index) => (
            <a
              key={index}
              href={social.url}
              target="_blank"
              rel="noopener noreferrer"
              className="w-14 h-14 bg-white/20 backdrop-blur-sm rounded-2xl flex items-center justify-center hover:bg-white/30 transition-all duration-300 hover:scale-110 animate-scale-in"
              style={{ animationDelay: `${index * 0.1}s` }}
            >
              <social.icon className="w-6 h-6 text-white" />
            </a>
          ))}
        </div>

        {/* Main Links */}
        <div className="space-y-4">
          {mainLinks.map((link, index) => (
            <a
              key={index}
              href={link.url}
              target="_blank"
              rel="noopener noreferrer"
              className={`block w-full p-5 bg-gradient-to-r ${link.gradient} rounded-2xl text-white shadow-xl hover:shadow-2xl transition-all duration-300 transform hover:scale-105 animate-fade-in`}
              style={{ animationDelay: `${index * 0.1}s` }}
            >
              <div className="flex items-center">
                <div className="w-14 h-14 bg-white/20 backdrop-blur-sm rounded-2xl flex items-center justify-center mr-4">
                  <link.icon className="w-7 h-7" />
                </div>
                <div className="flex-1">
                  <div className="font-bold text-lg">{link.title}</div>
                  <div className="text-sm opacity-90">{link.subtitle}</div>
                </div>
              </div>
            </a>
          ))}
        </div>

        {/* Office Location */}
        <div className="bg-white/10 backdrop-blur-sm rounded-2xl p-4 mt-6 animate-fade-in">
          <p className="text-white text-sm mb-3 text-center font-medium">🏢 Escritório de Desenvolvimento:</p>
          <MapComponent latitude={-8.7619} longitude={-63.9019} zoom={16} />
        </div>

        {/* Tech Badge */}
        <div className="bg-gradient-to-r from-cyan-500 to-blue-600 rounded-2xl p-4 mt-4 text-white text-center animate-fade-in">
          <p className="font-bold text-sm">⚡ Tecnologia de Ponta</p>
          <p className="text-xs opacity-90">React • Node.js • Python • AWS</p>
        </div>
      </div>
    </div>
  );
};

export default SoftwareLinktree;
